import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { Navigate, useParams } from "react-router-dom";
import Spinner from "react-bootstrap/Spinner";
import Header from "../components/Header";
import Footer from "../components/Footer";
import GuideStylePostBody from "../components/GuideStylePostBody";
import { fetchBlogBySlug } from "../data/blogPageHelpers";

function GuideStylePost() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);
  const [missing, setMissing] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [slug]);

  useEffect(() => {
    let cancelled = false;

    async function load() {
      setLoading(true);
      setMissing(false);
      try {
        const blog = await fetchBlogBySlug(slug);
        if (cancelled) return;
        if (!blog) {
          setMissing(true);
          setPost(null);
        } else {
          setPost(blog);
        }
      } catch (error) {
        console.error("Error loading guide-style post:", error);
        if (!cancelled) {
          setMissing(true);
          setPost(null);
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    }

    load();
    return () => {
      cancelled = true;
    };
  }, [slug]);

  if (missing) {
    return <Navigate to="/404" replace />;
  }

  const pageTitle =
    post?.seoTitle ||
    (post?.Caption ? `${post.Caption} | VCS Billing` : "VCS Billing");
  const pageDescription =
    post?.seoDescription || post?.intro || post?.Caption || "";

  return (
    <div className="rg-layout">
      <Helmet>
        <title>{pageTitle}</title>
        {pageDescription && (
          <meta name="description" content={pageDescription} />
        )}
      </Helmet>
      <div className="rg-chrome">
        <Header />
      </div>
      {loading || !post ? (
        <div
          className="rg-page"
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "50vh",
          }}
        >
          <div className="rg-parallax" aria-hidden="true" />
          <Spinner animation="border" role="status" variant="light">
            <span className="visually-hidden">Loading...</span>
          </Spinner>
        </div>
      ) : (
        <GuideStylePostBody post={post} />
      )}
      <div className="rg-chrome">
        <Footer />
      </div>
    </div>
  );
}

export default GuideStylePost;
